import { FormErrorMessage } from '@ksyos/design-system';
import { getValidationErrorTranslation } from '../../utils/getValidationErrorTranslation';

interface IFormValidationMessageProps {
    error?: string;
}

export function FormValidationMessage({ error }: IFormValidationMessageProps) {
    if (!error) {
        return <></>;
    }

    return <FormErrorMessage>{getValidationErrorTranslation(error)}</FormErrorMessage>;
}
